import * as React from "react";
import { SVGProps } from "react";
const SvgRatingNegative = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#rating-negative_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0Zm0 2C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14S23.732 2 16 2Zm0 15a9.002 9.002 0 0 1 8.224 5.339 1.002 1.002 0 0 1-.887 1.407.998.998 0 0 1-.94-.593 7.002 7.002 0 0 0-12.794 0 1 1 0 0 1-1.827-.814A9.002 9.002 0 0 1 16 17Zm-5.5-7a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm11 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="rating-negative_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRatingNegative;
